document.addEventListener("DOMContentLoaded", ()=> {
  initializeModalTermosECondicoes();
  initializeSubmitSpinner();
  initializeEmailFieldEvent();
});

function initializeModalTermosECondicoes() {
  $("#open-termos-de-uso").on("click", (ev)=> {
    ev.preventDefault();

    $("#modal-termos-de-uso").modal({
      show: true,
      backdrop: "static",
      keyboard: false,
    });
  });
}

function initializeSubmitSpinner() {
  $("#new_cadastro").on("submit", function () {
    $(this).addClass("hide");
    $(".register-title").text(
      `${window.t("interface.maino_flex.auto_cadastro.loading_user_create")}...`,
    );
    $(".register-title").parent().addClass("justify-content-center");
    $("#spinner-section").removeClass("hide");
  });
}

function initializeEmailFieldEvent() {
  const campoEmail = document.getElementById("email-auto-cadastro");

  campoEmail.addEventListener("change", function(event) {
    const email = event.target.value.trim();
    
    if (email && validaEmail(email)) {
      const nome = getNomeContato();
      enviaEventoRdStation("flex-incompleto", { email, nome });
    }
  });
}

function getNomeContato() {
  const campoNome = document.getElementById("nome-contato-auto-cadastro");
  return campoNome ? campoNome.value.trim() : "";
}

function validaEmail(email) {
  const regexEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return regexEmail.test(email);
}

function enviaEventoRdStation(conversionIdentifier, dadosPessoa) {
  const params = {
    conversion_identifier: conversionIdentifier,
    ...dadosPessoa
  };

  $.ajax({
    url: "/rd/registra_eventos",
    type: "POST",
    data: JSON.stringify(params),
    contentType: "application/json",
  });
}
